/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */

import { notEmptyPayload } from '_/utils/helpers'
import { get, patch, post } from './requests'
import humps from 'humps'

const decamelizeParams = params => {
  Object.values(params)?.map(param => {
    if (typeof param === 'string') {
      const replaceKey = Object.keys(params).find(paramKey => params[paramKey] === param)
      params[replaceKey] = humps.decamelize(param)
    }
  })
  return params
}

export const getAiAssistants = key => params => {
  const payloadParams = decamelizeParams(params)

  return get(['ai-assistant'], {
    key,
    transformPayload: true,
    params: humps.decamelizeKeys(notEmptyPayload(payloadParams)),
  })
}

export const getAssistantByIdService = key => id =>
  get(['ai-assistant', id], { key, transformPayload: true })

export const getAiErrorCorrection = key => params => {
  const payloadParams = decamelizeParams(params)

  return get(['ai-error-correction'], {
    key,
    transformPayload: true,
    params: humps.decamelizeKeys(notEmptyPayload(payloadParams)),
  })
}

export const getAiModels = key => params => {
  const payloadParams = decamelizeParams(params)

  return get(['ai-model'], {
    key,
    transformPayload: true,
    params: humps.decamelizeKeys(notEmptyPayload(payloadParams)),
  })
}

export const patchAssistantService = key => (id, payload) => {
  return patch(['ai-assistant', id], { key, transformPayload: true }, payload)
}

export const postAssistantService = key => payload => {
  return post(['ai-assistant'], { key, transformPayload: true }, payload)
}
export const updateAiErrorCorrectionService = key => (id, payload) =>
  patch(['ai-error-correction', id], { key, transformPayload: true }, payload)

export const postAiResponseService = key => payload =>
  post(['ai-model', 'ai-response'], { key, transformPayload: true }, payload)
